import React, { useEffect, useState } from "react";
import Service from "./Service";

const Services = () => {
  const [services, setServices] = useState([]);
  useEffect(() => {
    fetch("https://argos-laptop-garage-server.vercel.app/allservice")
      .then((res) => res.json())
      .then((data) => setServices(data));
  }, []);

  return (
    <div className="mt-10">
      <div>
        <h2 className="text-3xl text-center uppercase font-bold text-blue-500">
          {" "}
          Our Product{" "}
        </h2>
      </div>
      <div className="grid gap-6 grid-cold-1 md:grid-cols-2 lg:grid-cols-3">
        {services.map((service) => (
          <Service key={service._id} service={service}></Service>
        ))}
      </div>
    </div>
  );
};

export default Services;
